import api from '../api/axios'
import { RolApp } from '../types/auth'
import { Usuario } from '../types/usuario'

/** Solo administración (la API responde 403 al resto). */
export const usuarioService = {
  lista: async (): Promise<Usuario[]> => (await api.get<Usuario[]>('usuarios/')).data,
  registrar: async (datos: { rut: string; email: string; es_staff: boolean; roles: RolApp[] }): Promise<Usuario> =>
    (await api.post<Usuario>('usuarios/', datos)).data,
  cambiar: async (id: number, datos: { activo?: boolean; es_staff?: boolean; roles?: RolApp[] }): Promise<Usuario> =>
    (await api.patch<Usuario>(`usuarios/${id}/`, datos)).data,
}
